import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { NAWSurvey } from '../../../../../types/NAW/Survey'
import { Update } from '../../../../hooks/NAW/useNAWSurveyAnswer/useNAWSurveyAnswer'
import RangeWithLabelAndDescription from '../../Elements/RangeWithLabelAndDescription'
import HeadlineSplit from '../HeadlineSplit'
import getDigitalValue from '../Flaeche/getDigitalValue'
import getCollaborationValue from '../Arbeitsplaetze/getCollaborationValue'
import { useState } from 'react'
import Button from '../../../../UI/Button/Button'
import getHomeofficeLabel from '../Arbeitsplaetze/getHomeofficeLabel'

type Props = {
  survey: NAWSurvey
  update: Update
}

const Config: React.FC<Props> = ({ survey, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [showRanges, setShowRanges] = useState(false)

  const toggleRanges = () => setShowRanges(!showRanges)

  const Values = (
    <div className="flex flex-col justify-between gap-10 md:gap-5 h-full">
      <RangeWithLabelAndDescription
        value={survey.mitarbeiter}
        onChange={update('mitarbeiter')}
        label={t.naw.survey.attributes.mitarbeiter}
        description={t.naw.survey.answer.arbeitsplaetze.mitarbeiter}
        {...t.naw.survey.configuration.mitarbeiter}
        small
        toolTipLeftAlign
      />
      <RangeWithLabelAndDescription
        value={survey.homeoffice}
        onChange={update('homeoffice')}
        label={t.naw.survey.attributes.homeoffice}
        description={t.naw.survey.answer.arbeitsplaetze.homeoffice}
        customCurrentValueLabel={getHomeofficeLabel(survey.homeoffice)}
        {...t.naw.survey.configuration.homeoffice}
        small
        toolTipLeftAlign
      />
      <RangeWithLabelAndDescription
        value={survey.collaborationPercentage}
        onChange={update('collaborationPercentage')}
        label={t.naw.survey.attributes.collaborationPercentage}
        description={t.naw.survey.answer.arbeitsplaetze.collaborationPercentage}
        {...t.naw.survey.configuration.collaborationPercentage}
        customCurrentValueLabel={getCollaborationValue(survey.collaborationPercentage)}
        small
        toolTipLeftAlign
      />
      <RangeWithLabelAndDescription
        value={survey.digitalPercentage}
        onChange={update('digitalPercentage')}
        label={t.naw.survey.attributes.digitalPercentage}
        description={t.naw.survey.answer.flaeche.digitalPercentage}
        {...t.naw.survey.configuration.digitalPercentage}
        customCurrentValueLabel={getDigitalValue(survey.digitalPercentage)}
        small
        toolTipLeftAlign
      />
      <RangeWithLabelAndDescription
        value={survey.flaecheIst}
        onChange={update('flaecheIst')}
        label={t.naw.survey.attributes.flaecheIst}
        description={t.naw.survey.answer.flaeche.flaecheIst}
        {...t.naw.survey.configuration.flaecheIst}
        small
        toolTipLeftAlign
      />
      <RangeWithLabelAndDescription
        value={survey.pricePerSquareMeter}
        onChange={update('pricePerSquareMeter')}
        label={t.naw.survey.attributes.pricePerSquareMeter}
        description={t.naw.survey.answer.flaeche.pricePerSquareMeter}
        {...t.naw.survey.configuration.pricePerSquareMeter}
        small
        toolTipLeftAlign
      />
    </div>
  )

  return (
    <div className="flex flex-col gap-5 h-full md:pb-10">
      <div>
        <div className="hidden md:block">
          <HeadlineSplit suffix={t.naw.survey.answer.summary.config.suffix} subline={t.naw.survey.answer.summary.config.subline} />
        </div>
        <Button
          invert
          onClick={toggleRanges}
          className="w-full md:hidden mt-5 !border !border-green text-green hover:bg-white hover:!text-green"
          text={showRanges ? t.naw.survey.answer.summary.config.hideRanges : t.naw.survey.answer.summary.config.showRanges}
        />
      </div>
      <div className="md:hidden">{showRanges && Values}</div>
      <div className="hidden md:block h-full">{Values}</div>
    </div>
  )
}

export default Config
